module.exports = __webpack_public_path__ + "img/7_172.6e424683.png";